import ReactImageUploading from "react-images-uploading";
import {ImageListType} from "react-images-uploading/dist/typings";
import {useState} from "react";
import {useApp} from "../app.context";
import {useAccess} from "../utils/useAccess";
import {prepareImageUpload} from "../utils/file.utils";

function UploadButton(props: {
    id: string;
    // When set, awaited before the file dialog opens; returning false cancels.
    // Used to warn when replacing an image that several things share.
    confirmBeforeOpen?(): Promise<boolean>;
}) {
    const {uploadFile, setNotification} = useApp();
    const {canServerWrite} = useAccess();
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState<ImageListType>([]);

    async function onChange(value: ImageListType) {
        if (loading) return;
        setImages(value as never[]);

        const file = value[0]?.file;
        if (!file) return;

        // The picked file is uploaded as authored — no resizing (see
        // prepareImageUpload); a non-PNG is only re-encoded at its natural size.
        setLoading(true);
        try {
            await uploadFile(props.id, await prepareImageUpload(file));
        } catch (e) {
            setNotification({
                title: 'Could not read that image',
                message: e instanceof Error ? e.message : String(e),
            });
        }
        setImages([]);
        setLoading(false);
    }

    // Uploading a file is a server write (Tester+). Hidden for Viewer/Guest.
    if (!canServerWrite) return null;

    return (
        <ReactImageUploading value={images} onChange={onChange} maxNumber={1}>
            {({onImageUpload}) => (
                <button disabled={loading}
                        title={'Replace image'}
                        onClick={async () => {
                            if (props.confirmBeforeOpen && !(await props.confirmBeforeOpen())) return;
                            onImageUpload();
                        }}>
                    <span className={loading ? 'fa-solid fa-spinner' : 'fa-solid fa-file-import'}/>
                </button>
            )}
        </ReactImageUploading>
    );
}

export default UploadButton;
